<template>
  <section class="eventsSection my-16 px-4 px-md-10">
    <h2>{{ eventsData.title }}</h2>
    <ul class="eventList">
      <li
        v-for="eventItem in eventsData.eventList"
        :key="eventItem.slug"
        class="eventCardLarge"
      >
        <EventCard
          @actionClick="onActionClickHandler(eventItem)"
          :image="getImageLink(eventItem.image)"
        >
          <template v-slot:caption>Lsaran {{ eventItem.type }}</template>
          <template v-slot:description>{{ eventItem.topic }}</template>
          <template v-slot:info>
            <span>{{ getDateAsText(eventItem.date) }}</span>
            <span>{{ eventItem.time }}</span>
            <span>Location: {{ eventItem.location }}</span>
          </template>
        </EventCard>
      </li>
    </ul>

    <v-dialog
      v-if="selectedEvent != null"
      :value="selectedEvent"
      @click:outside="selectedEvent = null"
      max-width="752px"
    >
      <div class="dialogContent">
        <v-btn
          @click="selectedEvent = null"
          class="secondary-btn px-0 closeButton"
          tile
          fab
          small
          outlined
        >
          <v-icon class="">mdi-close</v-icon>
        </v-btn>

        <div class="dialogInfo">
          <img
            class="dialogImage"
            :src="getImageLink(selectedEvent.image)"
            alt=""
          />

          <div class="dialogTagWrapper">
            <span class="dialogTag">{{
              getDateAsText(selectedEvent.date)
            }}</span>
            <span class="dialogTag">{{ selectedEvent.time }}</span>
            <span class="dialogTag">{{ selectedEvent.location }}</span>
          </div>

          <v-btn
            v-if="selectedEvent.slug && isEventAvailable(selectedEvent)"
            :to="`/events/${selectedEvent.slug}`"
            class="main-btn dialogButton"
          >
            {{ eventsData.registerButtonName }}
          </v-btn>
        </div>
        <div class="dialogText">
          <div class="dialogCaption">
            <span class="text-uppercase">LSARAN {{ selectedEvent.type }}</span>
            <!--            <span class="dialogCaptionName">Aram Pakhchanyan</span>-->
          </div>
          <h2 class="dialogTitle">{{ selectedEvent.topic }}</h2>
          <div class="dialogDescription">
            <p v-html="selectedEvent.description" />
            <div class="mt-4" v-if="selectedEvent.format">
              <span>{{ eventsData.formatLabel }}:</span>
              <ul class="dialogFormatList">
                <li v-for="format in selectedEvent.format" :key="format">
                  - {{ format }}
                </li>
              </ul>
              <div></div>
              <p
                v-if="selectedEvent.info"
                class="dialogInfoDescription mt-4"
                v-html="selectedEvent.info"
              />
              <p
                v-if="eventsData.teamInfo"
                class="dialogInfoDescription mt-2"
                v-html="eventsData.teamInfo"
              />
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import moment from "moment";
import EventCard from "@/components/event-card/EventCard.vue";

export default {
  name: "EventsSection",
  components: { EventCard },
  computed: {
    eventsData() {
      return this.$t("events");
    }
  },
  data() {
    return {
      isPopupOpened: false,
      selectedEvent: null
    };
  },
  methods: {
    onActionClickHandler(eventItem) {
      this.selectedEvent = eventItem;
    },

    getImageLink(imageSrc) {
      return require(`@/assets/img${imageSrc}`);
    },

    getDateAsText(date) {
      const locale = this.$i18n.locale;
      moment.locale(locale === "am" ? "hy-am" : locale);

      return moment(date).format("D MMMM");
    },

    isEventAvailable(event) {
      return new Date(event.date).getTime() > new Date().getTime();
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/assets/style/vars";
@import "src/assets/style/media";

.hide-scrollbar {
  -ms-overflow-style: none; /* IE и Edge */
  scrollbar-width: none; /* Firefox */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.eventsSection {
  width: 100%;
}

.eventList {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  width: 100%;
  height: 100%;
  grid-gap: 32px;
  margin: 40px 0 0;
  padding: 0;
  list-style: none;

  @include tabletMedia {
    display: flex;
    flex-direction: column;
  }
}

.eventCardLarge {
  grid-column: 1 / 3;
  grid-row: 1 / 3;
}

.dialogContent {
  display: flex;
  grid-gap: 36px;
  position: relative;
  padding: 32px;
  max-height: 600px;
  background: $white;

  @include mobileMedia {
    flex-direction: column;
    padding-top: 52px;
    max-height: unset;
  }
}

.dialogInfo {
  width: 268px;
  flex-shrink: 0;

  @include mobileMedia {
    width: 100%;
  }
}

.dialogImage {
  width: 100%;
  height: 298px;
  object-fit: cover;

  @include mobileMedia {
    height: 254px;
  }
}

.dialogTagWrapper {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 8px;
  margin-top: 36px;

  @include mobileMedia {
    margin-top: 16px;
    grid-gap: 4px;
  }
}

.dialogTag {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  line-height: 1.1;
  border: 1px solid $prime;
  padding: 10px 8px;
}

.dialogButton {
  width: 100%;
  margin-top: 16px;
  font-size: 14px !important;
  line-height: 1.1 !important;
}

.closeButton {
  position: absolute;
  top: 32px;
  right: 32px;

  @include mobileMedia {
    width: 32px;
    height: 32px;
    top: 12px;
    right: 16px;
  }
}

.dialogText {
  width: 100%;
  height: 536px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  grid-gap: 16px;
  padding-right: 28px;

  @include mobileMedia {
    overflow-y: unset;
    height: unset;
  }
}

.dialogCaption {
  display: flex;
  flex-direction: column;
  grid-gap: 4px;
  color: $prime;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  line-height: 1.15;
}

.dialogCaptionName {
  font-size: 23px;
}

.dialogTitle {
  font-size: 24px;
  line-height: 1.1;

  @include mobileMedia {
    font-size: 20px;
  }
}

.dialogDescription {
  margin-top: 20px;

  * {
    margin: 0;
    font-size: 16px;
    line-height: 1.25;
  }
}

.dialogInfoDescription {
  font-size: 16px;
  line-height: 1.2;
  margin: 0;
}

.dialogFormatList {
  margin: 4px 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  grid-gap: 4px;
}
</style>
